import { Navigate, Outlet, NavLink } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { LayoutDashboard, Users, Wrench, FileText, BookOpen, Star, Settings, LogOut, Loader2 } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const navItems = [
  { path: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { path: "/admin/leads", label: "Leads", icon: Users },
  { path: "/admin/services", label: "Services", icon: Wrench },
  { path: "/admin/seo", label: "Pages SEO", icon: FileText },
  { path: "/admin/blog", label: "Blog", icon: BookOpen },
  { path: "/admin/avis", label: "Avis", icon: Star },
  { path: "/admin/settings", label: "Paramètres", icon: Settings },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-[#336DBF]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="flex min-h-screen bg-slate-50" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-slate-200 fixed left-0 top-0 h-screen flex flex-col z-30">
        <div className="p-5 flex items-center gap-3">
          <img src="/favicon.png" alt="Nettoyage Expert" className="w-9 h-9 rounded-md object-contain" />
          <div>
            <h1 className="font-heading text-base font-bold text-slate-900 leading-tight">Nettoyage Expert</h1>
            <p className="text-[11px] text-slate-500 font-medium tracking-wide uppercase">Administration</p>
          </div>
        </div>
        <Separator />
        <nav className="flex-1 p-3 space-y-0.5" data-testid="admin-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-[#336DBF]/8 text-[#336DBF] border-l-2 border-[#336DBF] ml-0"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
              data-testid={`nav-${item.path.split("/").pop() || "dashboard"}`}
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-200">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-slate-500 truncate">{user.email}</span>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 text-xs text-slate-500 hover:text-red-600 transition-colors"
            data-testid="logout-button"
          >
            <LogOut size={14} /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 min-h-screen">
        <div className="p-6 md:p-8 max-w-[1600px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
